<div class="print-only print-masthead">
  <!-- Ojo con el nombre: `Renda-Logo-White.png` es el de texto OSCURO, el que se lee sobre
       papel. `Rendafin.png` lleva "RENDA" en blanco y sobre fondo claro desaparece. -->
  <img class="print-masthead__logo" src="assets/media/images/logo/Renda-Logo-White.png" alt="Rendafin">
  <span class="print-masthead__tag">{{ footNote }}</span>
</div>

<div class="print-only print-title" *ngIf="title">
  <h1>{{ title }}</h1>
  <p *ngIf="subtitle || meta">
    {{ subtitle }}<span *ngIf="subtitle && meta"> · </span>{{ meta }}
  </p>
</div>

<!-- Se repite al pie de cada página impresa. -->
<div class="print-only print-foot">
  {{ footNote }} · {{ title }} · impreso el {{ printedAt | date: 'd MMM y, HH:mm' }}
</div>
